import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__title" }
const _hoisted_2 = { class: "popup__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createBlock(_Transition, { name: "popup" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "popup",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              ref: "popupWindow",
              class: _normalizeClass(["popup__window", { popup__window_dragging: _ctx.isDragging }]),
              style: _normalizeStyle(_ctx.dragStyle)
            }, [
              _createElementVNode("button", {
                class: "popup__close-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.description), 1),
              _renderSlot(_ctx.$slots, "default")
            ], 6)), [
              [_directive_touch, _ctx.popupTouchStopHandler, "release"],
              [_directive_touch, _ctx.popupTouchMoveHandler, "drag"],
              [_directive_touch, _ctx.popupTouchStartHandler, "press"]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}